import React, { useState } from "react";

const MasterDepositLogsTable = ({ deposits }) => {
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 5;

    // Sort deposits in descending order of requestId
    const sortedDeposits = [...deposits].sort((a, b) => b.requestId - a.requestId);

    // Filter by date range if both dates are selected
    const filteredDeposits = sortedDeposits.filter((deposit) => {
        if (!startDate || !endDate) return true;

        const depositDate = new Date(deposit.requestDate);
        const start = new Date(startDate);
        const end = new Date(endDate);
        end.setHours(23, 59, 59, 999); // Include full end day

        return depositDate >= start && depositDate <= end;
    });

    const totalPages = Math.ceil(filteredDeposits.length / rowsPerPage);

    const paginatedDeposits = filteredDeposits.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const totalAmount = filteredDeposits.reduce(
        (sum, deposit) => sum + parseFloat(deposit.amount || 0),
        0
    );

    return (
        <div className="mt-10 w-full">
            <h3 className="text-lg font-semibold">Cash Tracker Details</h3>

            <div className="my-4 flex gap-4">
                <input
                    type="date"
                    className="border p-2"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                />
                <input
                    type="date"
                    className="border p-2"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                />
            </div>

            <div className="overflow-x-auto">
                <table className="w-full border-collapse border border-gray-300 mt-2">
                    <thead>
                        <tr className="bg-green-100">
                            <th className="border p-2">Request ID</th>
                            <th className="border p-2">Amount</th>
                            <th className="border p-2">Request Date</th>
                            <th className="border p-2">Deposit Date</th>
                            <th className="border p-2">Deposit Mode</th>
                            <th className="border p-2">Approved Date</th>
                            <th className="border p-2">Narration</th>
                            <th className="border p-2">Bank</th>
                            <th className="border p-2">Current Status</th>
                            <th className="border p-2">Rejected Reason</th>
                        </tr>
                    </thead>
                    <tbody>
                        {paginatedDeposits.map((deposit, index) => (
                            <tr key={index} className="text-center">
                                <td className="border p-2">{deposit.requestId}</td>
                                <td className="border p-2">{deposit.amount}</td>
                                <td className="border p-2">{deposit.requestDate}</td>
                                <td className="border p-2">{deposit.depositDate}</td>
                                <td className="border p-2">{deposit.mode}</td>
                                <td className="border p-2">{deposit.approvedDate || "N/A"}</td>
                                <td className="border p-2">{deposit.narration}</td>
                                <td className="border p-2">{deposit.bank}</td>
                                <td className="border p-2">{deposit.action || "Pending"}</td>
                                <td className="border p-2">{deposit.rejectReason || "N/A"}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="flex justify-between mt-4">
                <button
                    className="px-4 py-2 bg-gray-300 rounded"
                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                >
                    Previous
                </button>
                <span>Page {currentPage} of {totalPages}</span>
                <button
                    className="px-4 py-2 bg-gray-300 rounded"
                    onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                    disabled={currentPage === totalPages}
                >
                    Next
                </button>
            </div>
        </div>
    );
};

export default MasterDepositLogsTable;
